import React from 'react';

import type { CrossReferenceElement } from '@aline/common';
import type { NodeEntry } from 'slate';

import { LinkIndicator } from './LinkIndicator';

interface CrossReferencePopoverContentProps {
  crossReferenceEntry: NodeEntry<CrossReferenceElement>;
}

export function CrossReferencePopoverContent({
  crossReferenceEntry,
}: CrossReferencePopoverContentProps): JSX.Element | null {
  return <LinkIndicator linkEntry={crossReferenceEntry} />;
}
